import vuetify from '@/plugins/vuetify'
import './scss/vuetifySettings.scss'

import 'vuetify/_styles.scss'
import './scss/main.css'
import './scss/main.scss'

import '/node_modules/@rfc/rfc-components-library/dist/scss/main.css'
// Style & Icons
import '@mdi/font/css/materialdesignicons.css'


import * as Vue from 'vue'
import App from './App.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'

import { interceptorsSetup } from '@rfc/rfc-components-library/helpers'
import i18n from './locales/i18n'
import router from './router'
import setupStore from './store'

const app = Vue.createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
library.add(fab)
library.add(fas)
library.add(far)

app.use(vuetify)

app.use(router)

const store = setupStore(router)

app.use(store)
app.use(i18n)
interceptorsSetup(store, router, i18n as any)

app.mount('#app')
